
import { Form, Input, Icon, Button, Row, Col, Select, DatePicker, Divider, message } from 'antd';
import React from 'react'
import MiCompAPI from '../../../util/api';
import moment from 'moment';

let id = 0;
const { MonthPicker } = DatePicker;


const { Option } = Select;
class EAD extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isloding: false, States: []
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.keys.length > 0) {

          let employmenT_HISTORYs = [];
          let { datE_FROM, datE_TO, employeR_NAME, position, statE_CODE, city, countrY_CODE } = values;
          let from = [];
          let to = [];
         
          Object.keys(datE_FROM).forEach(function (i) {
            from.push(datE_FROM[i]);
            to.push(datE_TO[i]);
            employmenT_HISTORYs.push({
              datE_FROM: moment(datE_FROM[i]).format("MMYYYY"),
              datE_TO: moment(datE_TO[i]).format("MMYYYY"), employeR_NAME: employeR_NAME[i], position: position[i]
              , statE_CODE: statE_CODE[i], city: city[i], countrY_CODE: countrY_CODE[i]
            })
          });
          var maxDate = moment.max(to);
          var minDate = moment.min(from);         
          if (moment(new Date()).diff(maxDate.add, "days") > 0) {
            message.error("The period" + moment(minDate).format("MMYYYY") + "to" + moment(maxDate).format("MMYYYY") + "extends into the future.");
            return;
          }
          if (maxDate.diff(minDate, "year") < 5) {
            message.error("Experience starting with your current employer working back five years required.",3);
            return;
          }
          this.props.submitHandler({ employmenT_HISTORY: employmenT_HISTORYs });
        } else {
          this.props.submitHandler({ employmenT_HISTORY: [] });

        }
      }
    });
  }
  remove = (k) => {

    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue('keys');
    // We need at least one passenger


    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  };

  add = () => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys,
    });
  };



  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { States } = this.props;

    let { employmenT_HISTORY } = this.props.niprappoinment;
    getFieldDecorator('keys', { initialValue: this.props.niprappoinment && employmenT_HISTORY ? employmenT_HISTORY : [{}] });
    const keys = getFieldValue('keys');
    const formItems = keys.map((k, index) => (
      <div key={index} >
        <Row >
          <Col md={12} sm={24}>

            <Form.Item>

              <fieldset className="mi_input_pop">
                <legend className="legend-font">From Date *</legend>
                {getFieldDecorator(`datE_FROM[${k}]`, {
                  initialValue: k.datE_FROM ? moment(new Date(k.datE_FROM.substring(2, 6) + "-" + k.datE_FROM.substring(0, 2))) : (index === 0 ? moment(new Date(new Date().setFullYear(new Date().getFullYear() - 5))) : null),
                  rules: [
                    {
                      required: true,
                      message: "Please enter From Date",
                    }
                  ],
                })(<MonthPicker autoComplete={"nope"} format="MM/YYYY" className="mi_input" />)}
              </fieldset>
            </Form.Item>
          </Col>

          <Col md={12} sm={24}>
            <Form.Item


            >
              <fieldset className="mi_input_pop">
                <legend className="legend-font">To Date *</legend>
                {getFieldDecorator(`datE_TO[${k}]`, {
                  initialValue: k.datE_TO ? moment(new Date(k.datE_TO.substring(2, 6) + "-" + k.datE_TO.substring(0, 2))) : (index === 0 ? moment(new Date()) : null),

                  rules: [
                    {
                      required: k === 0 ? false : true,
                      message: "Please enter To Date .",
                    }
                  ],
                })(<MonthPicker disabled={index === 0} autoComplete={"nope"} format="MM/YYYY" className="mi_input" />)}
              </fieldset>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Employers Name *</legend>
                {getFieldDecorator(`employeR_NAME[${k}]`, {
                  initialValue: k.employeR_NAME,
                  rules: [
                    {
                      required: true,
                      message: "Please enter Employers Name.",
                    },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "Employers Name is not valid"
                    }
                  ],
                })(<Input autoComplete={"nope"} maxLength={100} className="mi_input" placeholder="Enter Employers Name" />)}
              </fieldset>
            </Form.Item>
          </Col>

          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Position *</legend>
                {getFieldDecorator(`position[${k}]`, {
                  initialValue: k.position,
                  rules: [
                    {
                      required: true,
                      message: "Please enter Position.",
                    },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "Position is not valid"
                    }

                  ],
                })(<Input maxLength={25} autoComplete={"nope"} className="mi_input" placeholder="Enter Position" />)}
              </fieldset>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">City *</legend>
                {getFieldDecorator(`city[${k}]`, {
                  initialValue: k.city,
                  rules: [
                    {
                      required: true,
                      message: "Please enter City.",
                    },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "City is not valid"
                    }

                  ],
                })(<Input autoComplete={"nope"} maxLength={25} className="mi_input" placeholder="Enter City" />)}
              </fieldset>
            </Form.Item>
          </Col>

          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Country *</legend>
                {getFieldDecorator(`countrY_CODE[${k}]`, {
                  initialValue: '1',
                  rules: [{ required: true, message: 'Please enter Country' },],
                })(<Select disabled suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                  optionFilterProp="children"

                  showSearch={true}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Please Select Country ">
                  <Option value="1" key={0} >United States of America</Option>
                  <Option value="albania" key={1}>Albania</Option>
                  <Option value="afganisthan" key={2}>Afganisthan</Option>
                  <Option value="belgium" key={3}> Belgium</Option>
                  <Option value="india" key={4}> India</Option>
                  <Option value="iran" key={5}> Iran</Option>
                  <Option value="irak" key={6}> Irak</Option>
                </Select>)} </fieldset>
            </Form.Item>

          </Col>
        </Row>
        <Row>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">State *</legend>
                {getFieldDecorator(`statE_CODE[${k}]`, {
                  initialValue: k.statE_CODE,
                  rules: [{ required: true, message: 'Please enter state ' },],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                  optionFilterProp="children"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.onChange}
                  placeholder="Please Select State ">
                  {States.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}
                </Select>)}
              </fieldset>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={24}>


            {keys.length > 1 ? (
              <Button style={{ backgroundColor: "red", color: "white", float: "right", marginRight: "16px" }} onClick={() => this.remove(k)}> <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"


              ></Icon>Remove</Button>

            ) : null}
          </Col> </Row>
        <Divider></Divider> </div>


    ));
    return (


      <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark >
        <Row>
          <Col sm={24}><p style={{ background: '#9982821f', padding: '10px' }} >Account for all time for the past five years. Give all employment experience starting with your current employer working back five years. Include full and part-time work, self-employment, military service, unemployment and full-time education.</p></Col>

          <Col sm={24}>
            <Row>

              <Col md={24} sm={24}> {formItems}</Col>

              <Col md={24} sm={24}>

                <Button className=" ant-btn-primary" onClick={this.add} style={{ float: "right" }}>
                  <Icon type="plus" /> Add
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>



              </Col>
            </Row>
          </Col></Row>

        <div className="collapsepanel-footer">
          <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("exp")}> Back</Button>
          <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}> Next</Button>
        </div>

      </Form>
    );
  }
}


const NiprEmploymentHistory = Form.create()(EAD);

export default NiprEmploymentHistory;